// Community Apartment/Department Management APIs

/**
 * @function ApiClient#GetDepartmentList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetDepartmentList(cid, options = {}) {
  return await this._get(`/community/${cid}/department_list`, options);
}

/**
 * @function ApiClient#AddDepartment
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} typeName
 * @param {any} options = {}
 */
export async function AddDepartment(cid, typeName, options = {}) {
  return await this._post(`/community/${cid}/department?p=${typeName}`, null, options);
}

/**
 * @function ApiClient#UpdateDepartment
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} types
 * @param {any} options = {}
 */
export async function UpdateDepartment(cid, types, options = {}) {
  return await this._put(`/community/${cid}/department`, types, options);
}

/**
 * @function ApiClient#DeleteDepartment
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} typeName
 * @param {any} options = {}
 */
export async function DeleteDepartment(cid, typeName, options = {}) {
  return await this._delete(`/community/${cid}/department?p=${typeName}`, options);
}
